<template>
  <div class="home">
    <NavBar />
    <Header />
    <Services />    
    <About />
    <Footer />
  </div>
</template>
<script>
import NavBar from '@/components/NavBar.vue';
import Header from '@/components/Header.vue';
import Services from '@/components/Services.vue';
//import Portfolio from '@/components/Portfolio.vue';
import About from '@/components/About.vue';
//import Team from '@/components/Team.vue';
//import Contact from '@/components/Contact.vue';
import Footer from '@/components/Footer.vue';
//import PortfolioModals from '@/components/PortfolioModals.vue';

export default {
  name: 'Home',
  components: {
    NavBar,
    Header,
    Services,
    //Portfolio,
    About,
    //Team,
    //Contact,
    Footer,
    //PortfolioModals,
  },
};
</script>

<style scoped>
/* Add any specific styles for the Home view here if needed */
</style>
